import { render, staticRenderFns } from "./TestimonialCard.vue?vue&type=template&id=14e4a3e4&scoped=true&"
import script from "./TestimonialCard.vue?vue&type=script&lang=js&"
export * from "./TestimonialCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14e4a3e4",
  null
  
)

export default component.exports